import { computed, ref } from "vue";
import logoLight from "@/assets/logo-microcentrum2.png";
import logoDark from "@/assets/logoDark.png";
const STORAGE_KEY = "darkMode";
const isDarkMode = ref(false);
const followsSystem = ref(true);
let initialized = false;
let mediaQuery = null;
let mediaListener = null;
const getSystemPrefersDark = () => {
    if (typeof window === "undefined" || !window.matchMedia)
        return false;
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
};
const applyTheme = (dark) => {
    document.documentElement.setAttribute("data-bs-theme", dark ? "dark" : "light");
    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) {
        // Mismo navy del header/drawer en claro y oscuro
        themeColor.setAttribute("content", "#1e3a5f");
    }
    const statusBar = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]');
    if (statusBar) {
        statusBar.setAttribute("content", dark ? "black-translucent" : "default");
    }
};
const resolveDarkMode = () => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "true" || stored === "false") {
        followsSystem.value = false;
        return stored === "true";
    }
    followsSystem.value = true;
    return getSystemPrefersDark();
};
const detachSystemListener = () => {
    if (mediaQuery && mediaListener) {
        mediaQuery.removeEventListener("change", mediaListener);
    }
    mediaQuery = null;
    mediaListener = null;
};
const attachSystemListener = () => {
    detachSystemListener();
    if (typeof window === "undefined" || !window.matchMedia)
        return;
    if (!followsSystem.value)
        return;
    mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    mediaListener = (event) => {
        if (!followsSystem.value)
            return;
        isDarkMode.value = event.matches;
        applyTheme(isDarkMode.value);
    };
    mediaQuery.addEventListener("change", mediaListener);
};
export const useDarkMode = () => {
    const syncFromStorageOrSystem = () => {
        isDarkMode.value = resolveDarkMode();
        applyTheme(isDarkMode.value);
        attachSystemListener();
    };
    const initializeDarkMode = () => {
        if (initialized) {
            syncFromStorageOrSystem();
            return;
        }
        syncFromStorageOrSystem();
        initialized = true;
    };
    const setDarkMode = (dark) => {
        followsSystem.value = false;
        isDarkMode.value = dark;
        localStorage.setItem(STORAGE_KEY, String(dark));
        applyTheme(dark);
        detachSystemListener();
    };
    const toggleDarkMode = () => {
        setDarkMode(!isDarkMode.value);
    };
    /** Vuelve a seguir la preferencia del sistema. */
    const followSystemPreference = () => {
        localStorage.removeItem(STORAGE_KEY);
        followsSystem.value = true;
        isDarkMode.value = getSystemPrefersDark();
        applyTheme(isDarkMode.value);
        attachSystemListener();
    };
    const brandLogoSrc = computed(() => isDarkMode.value ? logoDark : logoLight);
    return {
        isDarkMode,
        followsSystem,
        brandLogoSrc,
        initializeDarkMode,
        toggleDarkMode,
        setDarkMode,
        followSystemPreference,
    };
};
